import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { Field } from 'redux-form';

import IconCross from 'components/icons/IconCross';
import IconButton from 'components/common/IconButton';
import Menu from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';

import ReportsCreateEditFormField from './ReportsCreateEditFormField';

const styles = theme => ({
  root: {
    position: 'relative',
    paddingTop: 24,
    paddingBottom: 24,
    paddingRight: 16,
    borderBottom: `1px solid ${theme.palette.primary.A400}`,
  },
  buttonRemove: {
    position: 'absolute',
    top: '50%',
    right: -15,
    transform: 'translateY(-50%)',
  },
  iconCross: {
    width: 15,
    height: 15,
  },
});

class ReportsCreateEditFormSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };

    this.onMenuClose = this.onMenuClose.bind(this);
    this.onRemoveButtonClick = this.onRemoveButtonClick.bind(this);
    this.onRemoveCancel = this.onRemoveCancel.bind(this);
    this.onRemoveSubmit = this.onRemoveSubmit.bind(this);
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onRemoveButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  onRemoveCancel() {
    this.setState({ anchorEl: null });
  }

  onRemoveSubmit() {
    this.props.onRemove();
    this.setState({ anchorEl: null });
  }

  render() {
    const {
      fields,
      input,
      meta,
      names,
      label,
      separator,
      filters,
      classes,
      ...otherProps
    } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    let menuName;
    if (fields) {
      menuName = `${fields.name}-remove-menu`;
    }
    if (names) {
      menuName = `${names.join('-')}-remove-menu`;
    }
    if (input) {
      menuName = `${input.name}-remove-menu`;
    }
    if ((fields && fields.length === 0)
      || (input && input.value.length === 0)
      || (names && names.filter(item =>
        otherProps[item].input.value.length !== 0
          && !otherProps[item].meta.error).length < names.length)
      || (meta && meta.error)) {
      return '';
    }

    return (
      <Grid
        className={classes.root}
        container
        alignItems="center"
        spacing={0}
        wrap="nowrap"
      >
        <Grid item xs={12}>
          {label &&
            <Typography
              color="secondary"
              gutterBottom
            >
              {label}
            </Typography>
          }
          {fields && fields.map((field, index) => (
            <Field
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              name={field}
              component={ReportsCreateEditFormField}
              {...(index !== 0 && separator) ? { prefix: separator } : {}}
            />
          ))}
          {names && names.map((name, index) => {
            let value = otherProps[name].input.value;
            if (name === 'Step Value'
              && Number(otherProps['Step Number'].input.value) > 1) {
              value = `${value}s`;
            }
            if (value.length > 0) {
              return (
                <ReportsCreateEditFormField
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  input={{
                    value: {
                      label: value,
                    },
                  }}
                  {...(index !== 0 && separator) ? { prefix: separator } : {}}
                />
              );
            }
            return null;
          })}
          {input &&
            <ReportsCreateEditFormField
              input={{
                value: {
                  label: input.value,
                },
              }}
            />
          }
          {filters && filters['Report Order Line Rejected'] &&
          <ReportsCreateEditFormField
            input={{
              value: {
                label: filters['Report Order Line Rejected'].length === 2
                  ? 'Active, Rejected Orders' : 'Rejected Orders',
              },
            }}
          />
          }
          <IconButton
            className={classes.buttonRemove}
            aria-label="Remove"
            aria-owns={open ? menuName : null}
            aria-haspopup="true"
            onClick={this.onRemoveButtonClick}
            tooltipContent="Remove Filter"
          >
            <IconCross className={classes.iconCross} />
          </IconButton>
          <Menu
            id={menuName}
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list={false}
          >
            <DeleteMenu
              text="Are you sure you want to delete this filter?"
              onCancel={this.onRemoveCancel}
              onSubmit={this.onRemoveSubmit}
            />
          </Menu>
        </Grid>
      </Grid>
    );
  }
}

ReportsCreateEditFormSection.propTypes = {
  fields: PropTypes.shape({
    name: PropTypes.string,
  }),
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.shape({
        label: PropTypes.string,
      }),
      PropTypes.string,
    ]),
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
  }),
  names: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  separator: PropTypes.string,
  onRemove: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    'Report Order Line Rejected': PropTypes.arrayOf(PropTypes.bool),
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    buttonRemove: PropTypes.string.isRequired,
    iconCross: PropTypes.string.isRequired,
  }).isRequired,
};

ReportsCreateEditFormSection.defaultProps = {
  fields: null,
  input: null,
  meta: null,
  names: null,
  label: null,
  separator: null,
  filters: null,
};

export default withStyles(styles)(ReportsCreateEditFormSection);



// WEBPACK FOOTER //
// ./src/components/reports/ReportsCreateEditForm/ReportsCreateEditFormSection.js